import React, { createContext, useMemo } from 'react';

import { type ApolloClient } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';
import { createPlatformApiClient } from '@dashboard/utilities/apollo';

type TContext = {
  platformApiClient: ApolloClient<Record<string, unknown>>;
};

export const CurrentPlatformContext = createContext<TContext | null>(null);

type Props = {
  uri: string;
  children: JsxNode;
};
export default function PlatformManager({ uri, children }: Props): JsxNode {
  const { getAccessTokenSilently } = useAuth0();
  const context = useMemo<TContext | null>(() => {
    return {
      platformApiClient: createPlatformApiClient({ uri, getAccessTokenSilently }),
    };
  }, [uri, getAccessTokenSilently]);

  return <CurrentPlatformContext.Provider value={context}>{children}</CurrentPlatformContext.Provider>;
}
